__webpack_require__.p = "/LanguageTranslatorApp/";